﻿
import angular from 'angular';

import '../../../services/mailchimp';

angular.module('folkeuni').component('newsletter', {
  templateUrl: '/shop-dist/templates/newsletter.html?c=' + window.cacheBurst,
  transclude: false,
  bindings: {
    preSelectedCategory: '@',
    siteId: '@'
  },
  controller: function(Mailchimp) {
    var $ctrl = this;

    $ctrl.loading = false;

    $ctrl.$onInit = function() {
      if (!$ctrl.preSelectedCategory || $ctrl.siteId == 15) {
         Mailchimp.categoriesGetBySiteId($ctrl.siteId).then(function(categories) {
             $ctrl.interests = categories;
         });
      } 
    }

    $ctrl.submit = function() {
      $ctrl.loading = true;
      var valid = true;
      $ctrl.statusMessage = "";
      $ctrl.statusClass = "";

      if (!$ctrl.emailAddress) {
        valid = false;
        $ctrl.statusMessage = "Du skal indtaste din e-mailadresse.";
        $ctrl.statusClass = "error";
      }

      if (valid) {
        var subscriberObj = {
          email_address: $ctrl.emailAddress,
          interests: {}
        }


        if ($ctrl.preSelectedCategory) {
          subscriberObj.interests[$ctrl.preSelectedCategory] = true;

        }
        
        for (i in $ctrl.interests) {
          var currentInterest = $ctrl.interests[i];

          for (y in currentInterest.options) {
            var currentOption = currentInterest.options[y];

            subscriberObj.interests[currentOption.id] = currentOption.selected;
          }
        }
        
        Mailchimp.subscribe($ctrl.siteId, subscriberObj).then(function(successResponse) {

          $ctrl.statusMessage = successResponse.message;
          if (successResponse.StatusCode == 200) {
            $ctrl.statusClass = "success";
          } else {
            $ctrl.statusClass = "warning";
          }

          $ctrl.loading = false;
        }, function(errorResponse) {
          $ctrl.statusMessage = errorResponse.message;
          $ctrl.statusClass = "error";

          $ctrl.loading = false;

          console.log("error", errorResponse);
        });
      } else {
        $ctrl.loading = false;
      }
    }

  }
});
